import React, { Fragment, useState } from 'react';
import { isTablet, isMobile } from 'react-device-detect';
import ReactDOM from 'react-dom';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { IState } from 'services/root-reducer';
import { EOperationStatus, IOperation } from 'types';
import { switchLanguage } from 'utils/lang';

import {
    getOperationSafe,
    getOmjsViewInstance,
    getOperationData
} from 'selectors';

import { RouteComponentProps, withRouter, matchPath } from 'react-router-dom';
import { actions as appActions } from 'services/app/app-service';

import { actions as mapActions } from 'services/map/map-service';
import { Icons, Button, ButtonGroup } from 'components';
import { actions as overlayWindowsActions } from 'services/overlay-windows/overlay-windows-service';
import { routes } from 'routes';
import { Map } from './map';
import { MapZoomControl } from './controls/zoom-control';
import { BaseMapSwitcher } from './controls/base-map-switcher';
import { LinksControl } from './controls/links';
import { MeasurementsControl } from './controls/measurements-control';
import { MapToImageControl } from './controls/map-to-image-control';
import { UserMenu } from './controls/user-menu';
import { ObjectsComparisonMenu } from './controls/objects-comparison-menu';

import { ObjectFiltersWindow } from './controls/object-filters-window';
import './style.scss';


interface IMapWrapperPros extends RouteComponentProps {
    publicationSettings: IState['app']['config']['publication'];
    controlsContainerRef: HTMLDivElement;
    omjsReady: IOperation;
    view: IState['omjs']['omjsViewInstance'];
    mapState: IState['operations']['MAP_STATE']['data'];
    centerFromUrl: string;
    zoomFromUrl: string;
    layersFromUrl: string;
    filtersWindowVisible: IState['app']['filtersWindowVisible']
}

const mapStateToProps = (state: IState) => ({
    publicationSettings: state.app.config.publication,
    omjsReady: getOperationSafe(state, 'OMJS_READY'),
    view: getOmjsViewInstance(state),
    mapState: getOperationData(state, 'MAP_STATE'),
    filtersWindowVisible: state.app.filtersWindowVisible
});

const MapWrapperComponent: React.FC<IMapWrapperPros> = (props): JSX.Element => {
    const {
        publicationSettings,
        controlsContainerRef,
        omjsReady,
        view,
        mapState,
        centerFromUrl,
        zoomFromUrl,
        layersFromUrl,
        filtersWindowVisible,
        match,
        location
    } = props;

    let objectWndVisible = false;
    for (let route_object of routes) {
        if (matchPath(location.pathname, route_object)) {
            if (route_object === routes.objectShort) {
                objectWndVisible = true;
            }
            break;
        }
    }

    const compareWndVisible = match.params[0].indexOf('/compare') === 0;
    const listWndVisible = match.params[0].indexOf('/list') === 0;
    objectWndVisible = objectWndVisible || match.params[0].indexOf('/object') === 0;

    let [ isUserMenuOpened, setUserMenuOpened ] = useState(false);
    let [ isObjectsComparisonOpened, setObjectsComparisonOpened ] = useState(false);
    const { t } = useTranslation();

    const isRequestForProductionVisible = () => {
        if (isTablet) {
            return (
                !compareWndVisible
                && !isUserMenuOpened
                && !isObjectsComparisonOpened
                && !objectWndVisible
                && !listWndVisible
            );
        } else {
            return !compareWndVisible;
        }
    };

    const isMapControlsVisible = () => {
        if (isTablet) {
            return (
                !listWndVisible && !objectWndVisible
            );
        } else {
            return true;
        }
    };

    const renderObjecFiltersWindow = () => {
        if (filtersWindowVisible) {
            if (isTablet && !!matchPath(location.pathname, routes.list)) {
                return null;
            }

            return (
                <ObjectFiltersWindow
                    onClose={() => appActions.hideObjectFiltersWindow()}
                />
            );
        } else {
            return null;
        }
    };
    // horizontal
    const renderMapControls = (): JSX.Element => (
        <Fragment>
            <MapZoomControl map={view.getMap()} settings={publicationSettings.map_position} />

            {renderObjecFiltersWindow()}

            <ButtonGroup className="app-tools-group" orientation='horizontal'>
                {isRequestForProductionVisible() && (
                    <Button
                        className="request-for-production"
                        variant='blue'
                        text={t('Получить консультацию')}
                        onClick={() => {
                            overlayWindowsActions.showApplicationOverlay({
                                objects: []
                            });
                        }}
                    />
                )}
                {isMapControlsVisible() && !compareWndVisible && !isUserMenuOpened && (
                    <ObjectsComparisonMenu
                        open={isObjectsComparisonOpened}
                        onOpen={() => {
                            setObjectsComparisonOpened(true);
                            setUserMenuOpened(false);
                        }}
                        onClose={() => {
                            setObjectsComparisonOpened(false);
                            setUserMenuOpened(false);
                        }}
                        onCompareClick={() => {
                            appActions.hideObjectFiltersWindow();
                            setObjectsComparisonOpened(false);
                            routes.redirect(routes.compareObjects);
                        }}
                    />
                )}
                {/* {isMapControlsVisible() && !isUserMenuOpened && ( */}
                {/*    <Button */}
                {/*        variant='black' */}
                {/*        icon={( */}
                {/*            i18next.language === 'ru' */}
                {/*                ? <Icons.IconLangEn /> */}
                {/*                : <Icons.IconLangRu /> */}
                {/*        )} */}
                {/*        onClick={() => { */}
                {/*            switchLanguage(); */}
                {/*        }} */}
                {/*    /> */}
                {/* )} */}
                {isMapControlsVisible() && (
                    <UserMenu
                        open={isUserMenuOpened}
                        onOpen={() => {
                            setUserMenuOpened(true);
                            setObjectsComparisonOpened(false);
                        }}
                        onClose={() => {
                            setUserMenuOpened(false);
                            setObjectsComparisonOpened(false);
                        }}
                        buttonProps={{
                            variant: 'blue',
                            className: 'app-menu-button'
                        }}
                    />
                )}
            </ButtonGroup>

            {!isUserMenuOpened && (
                <ButtonGroup orientation='vertical' className="map-tools-group">
                    <LinksControl />
                    <BaseMapSwitcher
                        layersList={publicationSettings.base_maps}
                        lng={view.getProject().lng as string}
                        currentBaseMapId={mapState.baseMapId}
                        cadastreIsVisible={mapState.cadastreVisible}
                        showCadastreLayer={mapActions.showCadastreLayer}
                        switchBaseMap={mapActions.switchBaseLayer}
                    />
                    <MeasurementsControl view={view} />
                    { !__IS_CORDOVA__ && (
                        <Button
                            icon={<Icons.IconLink />}
                            variant='black'
                            onClick={() => {
                                let protocol = (window.location.protocol !== 'https:') ? 'http:' : 'https:';
                                let { port } = window.location;
                                port = port ? `:${port}` : '';
                                /* eslint-disable-next-line */
                                let base_url = `${ protocol }//${ window.location.hostname }${ port }${ window.location.pathname }${ window.location.search }`;
                                let current_route = routes.getCurrentRoute();
                                let map_link = routes.map.construct({
                                    container: current_route.params?.container ?? 'root',
                                    center: current_route.params?.center,
                                    zoom: current_route.params?.zoom,
                                    layers: current_route.params?.layers
                                });

                                overlayWindowsActions.showMapLinkOverlay(`${base_url}#${map_link}`);
                            }}
                        />
                    )}
                    {!isMobile && (
                        <Button
                            variant='black'
                            icon={<Icons.IconPrint />}
                            onClick={() => {
                                mapActions.printMap();
                            }}
                        />
                    )}
                    { !__IS_CORDOVA__ && !isMobile && (
                        <MapToImageControl
                            view={view}
                            currentBaseMapId={mapState.baseMapId}
                            layersList={publicationSettings.base_maps}
                        />
                    )}
                </ButtonGroup>
            )}

            <Button
                onClick={() => {
                    overlayWindowsActions.showReportErrorOverlay();
                }}
                className='feedback-button'
                variant='white'
                text={t('Сообщить об ошибке')}
            />
        </Fragment>
    );

    return (
        <div className="oms-map-wrapper">
            <Map centerFromUrl={centerFromUrl} zoomFromUrl={zoomFromUrl} layersFromUrl={layersFromUrl} />
            {(controlsContainerRef && omjsReady.status === EOperationStatus.SUCCESS) && (
                ReactDOM.createPortal(
                    renderMapControls(),
                    controlsContainerRef
                )
            )}
        </div>
    );
};

export const MapWrapper = withRouter(
    connect(mapStateToProps)(
        MapWrapperComponent
    )
);
